export default __webpack_public_path__ + "static/media/FD1.96334fe2.png";